module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.1025 5.09902L11.0998 5.08809L9.56579 1.19023C9.49743 0.970117 9.29372 0.818359 9.06267 0.818359H2.8447C2.61228 0.818359 2.40583 0.972852 2.34021 1.1957L0.906027 5.05391L0.901926 5.06348L0.899191 5.07441C0.881418 5.14141 0.875949 5.20976 0.885519 5.27676C0.884152 5.29863 0.882785 5.32051 0.882785 5.34238V10.3449C0.883146 10.5653 0.97084 10.7765 1.12665 10.9323C1.28246 11.0881 1.49368 11.1758 1.71403 11.1762H10.289C10.747 11.1762 11.1203 10.8029 11.1217 10.3449V5.34238C11.1217 5.32461 11.1217 5.30684 11.1203 5.2918C11.1258 5.2248 11.1203 5.16055 11.1025 5.09902ZM7.05837 4.51113L7.05427 4.72578C7.04333 5.33965 6.6195 5.75254 6.00017 5.75254C5.69802 5.75254 5.43825 5.65547 5.25095 5.4709C5.06364 5.28633 4.96111 5.0293 4.95564 4.72578L4.95153 4.51113H2.13786L3.22478 1.86836H8.68259L9.79958 4.51113H7.05837ZM1.93142 5.56113H4.082C4.41423 6.3418 5.12107 6.80254 6.00153 6.80254C6.46228 6.80254 6.89021 6.67402 7.23611 6.43066C7.53962 6.21738 7.77614 5.91934 7.92927 5.56113H10.0689V10.1262H1.93142V5.56113Z",
      "fill": "#004A98"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0493fbb4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0493fbb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/UnionIcon.vue
// module id = 1473
// module chunks = 159